import type { ReactElement } from 'react';
import type { IconRenderProps } from '../types';

export function ArrowLeftIcon({
	width = 32,
	height = 16,
	color = 'currentColor',
	opacity,
	style,
	...rest
}: IconRenderProps): ReactElement {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 32 16"
			fill="none"
			aria-hidden="true"
			style={{ display: 'block', opacity, ...style }}
			{...rest}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M0.29325 8.70686L7.29319 15.7068C7.68419 16.0977 8.31619 16.0977 8.70718 15.7068C9.09818 15.3158 9.09818 14.6838 8.70718 14.2928L3.41423 8.99986L31 8.99986C31.552 8.99986 32 8.55187 32 7.99988C32 7.44788 31.552 6.99989 31 6.99989L3.41423 6.99989L8.70719 1.70697C9.09818 1.31598 9.09818 0.683988 8.70719 0.292993C8.51219 0.0979966 8.25619 -2.07575e-06 8.00019 -2.09813e-06C7.74419 -2.12051e-06 7.48819 0.0979965 7.2932 0.292993L0.29325 7.29288C-0.0977471 7.68388 -0.0977471 8.31587 0.29325 8.70686Z"
				fill={color}
			/>
		</svg>
	);
}
